window.dict_formulatemplate = function () {

    var instance = {
        closeDialog: function () {
            alert("dict_formulatemplate");
            var dialog = document.querySelector("div[id='info_formulatemplate_viewlist_dialog']");
            if (dialog != null)
                dialog.remove();
        },
    }
    return instance;
}();

window.formulalistdefault = function () {

    var instance = {
        closeDialog: function () {
            alert("formulalistdefault");
            var dialog = document.querySelector("div[id='info_formulatemplate_viewlist_dialog']");
            if (dialog != null)
                dialog.remove();
        },
    }
    return instance;
}();

window.tabpagepartformulatext = function () {

    var instance = {
        closeDialog: function () {
            alert("tabpagepartformulatext");
            var dialog = document.querySelector("div[id='info_formulatemplate_viewlist_dialog']");
            if (dialog != null)
                dialog.remove();
        },
    }
    return instance;
}();

window.infotp2oursideviewbottomright = function () {

    var instance = {
        closeDialog: function () {
            alert("infotp2oursideviewbottomright");
            var dialog = document.querySelector("div[id='info_formulatemplate_viewlist_dialog']");
            if (dialog != null)
                dialog.remove();
        },
    }
    return instance;
}();


